import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  }, []);

  // One-click sign-in. The button posts an ADDRESS only -- the password lives on
  // the server and never reaches the bundle -- and the server answers through
  // the ordinary login handler, so the session is identical to a typed one.
  const demoLogin = useCallback(async (email) => {
    const { data } = await api.post("/auth/demo-login", { email });
    setUser(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    setUser(false);
  }, []);

  return <Ctx.Provider value={{ user, setUser, login, demoLogin, logout }}>{children}</Ctx.Provider>;
}

export const useAuth = () => useContext(Ctx);
